<template>
    <div class="splash">
        <!--
        <img src="../assets/images/splash-healthtalk@3x.png" class="health-talk" :class="isiOS ? 'ios': ''"><br/>
        <img src="../assets/images/splash-orangelife@3x.png" class="orange" :class="isiOS ? 'ios': ''"><br/>
        -->
        <img src="../../assets/images/healthtalk.jpg" class="splash-img">
    </div>
</template>
<script>
	import { mapActions } from "vuex"
    export default {
        components: {
        },
        data() {
            return {
            }
        },
        computed: {
            isiOS () {
                return /iPhone|iPad|iPod/i.test(navigator.userAgent);
            }
        },
        mounted() {
            this.setHome('/sh')
            setTimeout(() => {
                this.$router.push('/intro')
            }, 2000)
        },
        methods: {
            ...mapActions('user', [
                'setHome',
            ])
        }
    }
</script>
<style scoped>
    .splash {
        display: relative;
        width: 100vw;
        height: 100vh;
        text-align: center;
        /*background-color: #f16522;*/
        background-color: #404040;
    }

    @media screen and (min-width: 501px) {
        .splash {
            display: relative;
            width: 500px;
            height: 100vh;
            text-align: center;
            /*background-color: #f16522;*/
            background-color: #404040;
        }
    }

    .fadeOut {
        animation: fadeOut ease 1s;
        -webkit-animation: fadeOut ease 1s;
        -moz-animation: fadeOut ease 1s;
        -o-animation: fadeOut ease 1s;
        -ms-animation: fadeOut ease 1s;        
    }

    @keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-moz-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-webkit-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-o-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    @-ms-keyframes fadeOut {
        0% {
            opacity:1;
        }
        100% {
            opacity:0;
        }
    }

    .splash-img {
        width: 95%;
    }

    .health-talk {
        margin-top: 20vh;
        width: 50vw;
    }
    .health-talk.ios {
        margin-top: 25vh;
    }

    .orange {
        margin-top: 30vh;
        width: 38vw;
    }
    .orange.ios {
        margin-top: 20vh;
    }


</style>
